module.exports = __webpack_public_path__ + "img/gift4-01-c05-y1.531f0bdd.png";